export function usuarios() {
    return [
        { "email": "guilherme.emailmultiedro@multiedro.info" },
        { "email": "guilherme@multiedro.info" },
        { "email": "usuario 2" },
        { "email": "usuario 3" },
        { "email": "usuario 4" },
        { "email": "usuario 5" },
        { "email": "usuario 6" },
        { "email": "usuario 7" },
        { "email": "usuario 8" },
        { "email": "usuario 9" },
        { "email": "usuario 10" },
        { "email": "usuario 11" },
        { "email": "usuario 12" },
        { "email": "usuario 13" },
        { "email": "usuario 14" },
        { "email": "usuario 15" },
        { "email": "usuario 16" },
        { "email": "usuario 17" },
        { "email": "usuario 18" },
        { "email": "usuario 19" },
        { "email": "usuario 20" },
        { "email": "usuario 21" },
    ]
}


export function grupos() {
    return {
        lista: [
            {
                "idExterno": "01ljsd9k47u81sn",
                "nome": "sub-dominio-1@teste.direcaocultura.com.br"
            },
            {
                "idExterno": "039kk8xu2s3gu8c",
                "nome": "criado-por-adm@multiedro.info"
            },
            {
                "idExterno": "01ljsd9k47u81sn1",
                "nome": "sub-dominio@teste.direcaocultura.com.br"
            },
        
            {
                "idExterno": "01ljsd9k47u81sn2",
                "nome": "sub-dominio-2@teste.direcaocultura.com.br"
            },
            {
                "idExterno": "01ljsd9k47u81sn3",
                "nome": "sub-dominio-3@teste.direcaocultura.com.br"
            },
            {
                "idExterno": "01ljsd9k47u81sn4",
                "nome": "sub-dominio-4@teste.direcaocultura.com.br"
            },
            {
                "idExterno": "01ljsd9k47u81sn5",
                "nome": "sub-dominio-5@teste.direcaocultura.com.br"
            },
            {
                "idExterno": "01ljsd9k47u81sn6",
                "nome": "sub-dominio-6@teste.direcaocultura.com.br"
            },
            {
                "idExterno": "01ljsd9k47u81sn7",
                "nome": "sub-dominio-7@teste.direcaocultura.com.br"
            },
            {
                "idExterno": "01ljsd9k47u81sn8",
                "nome": "sub-dominio-8@teste.direcaocultura.com.br"
            },
            {
                "idExterno": "01ljsd9k47u81sn6yg",
                "nome": "sub-dominio-6@teste.direcaocultura.com.br"
            },
            {
                "idExterno": "01ljsd9k47u81sn78",
                "nome": "sub-dominio-7@teste.direcaocultura.com.br"
            },
            {
                "idExterno": "01ljsd9k47u81sn88",
                "nome": "sub-dominio-8@teste.direcaocultura.com.br"
            },
            {
                "idExterno": "01ljsd9k47u81sn68",
                "nome": "sub-dominio-6@teste.direcaocultura.com.br"
            },
            {
                "idExterno": "01ljsd9k47ugg81sn7",
                "nome": "sub-dominio-7@teste.direcaocultura.com.br"
            },
            {
                "idExterno": "01ljsd9k47kku81sn87",
                "nome": "sub-dominio-8@teste.direcaocultura.com.br"
            },
            {
                "idExterno": "01ljsd9k47ugg81sn78",
                "nome": "sub-dominio-7@teste.direcaocultura.com.br"
            },
            {
                "idExterno": "01ljsd9k47u8kk1sn88",
                "nome": "sub-dominio-8@teste.direcaocultura.com.br"
            },
            {
                "idExterno": "01ljsd9k47u81sngg68",
                "nome": "sub-dominio-6@teste.direcaocultura.com.br"
            },
            {
                "idExterno": "01ljsd9k47u81sngg7",
                "nome": "sub-dominio-7@teste.direcaocultura.com.br"
            },
            {
                "idExterno": "01ljsd9k47u81sn8uh7",
                "nome": "sub-dominio-8@teste.direcaocultura.com.br"
            },
            {
                "idExterno": "01ljsd9k47u81sn10",
                "nome": "sub-dominio@teste.direcaocultura.com.br"
            },
        
            {
                "idExterno": "01ljsd9k47u81sn11",
                "nome": "sub-dominio-2@teste.direcaocultura.com.br"
            },
            {
                "idExterno": "01ljsd9k47u81sn12",
                "nome": "sub-dominio-3@teste.direcaocultura.com.br"
            },
            {
                "idExterno": "01ljsd9k47u81sn13",
                "nome": "sub-dominio-4@teste.direcaocultura.com.br"
            },
            {
                "idExterno": "01ljsd9k47u81s145",
                "nome": "sub-dominio-5@teste.direcaocultura.com.br"
            },
            {
                "idExterno": "01ljsd9k47u81sn86",
                "nome": "sub-dominio-6@teste.direcaocultura.com.br"
            },
            {
                "idExterno": "01ljsd9k47u81sn97",
                "nome": "sub-dominio-7@teste.direcaocultura.com.br"
            },

        ],
    }

}